<template>
  <!-- 充值详情 -->
  <div class="order-money-container">
    <div class="top">
      <div class="header">
        <div class="label">顾客信息</div>
        <!-- <div class="tui">退充</div> -->
      </div>
      <van-cell-group>
        <van-cell title="联系人" :value="userInfo.contactPerson" />
        <van-cell title="手机号" :value="userInfo.mobile" />
      </van-cell-group>
    </div>
    <div class="bottom">
      <div class="label">充值</div>
      <van-cell-group>
        <van-cell title="充值方式" :value="userInfo.rechargeType == '1' ? '微信':'支付宝'" />
        <van-cell title="充值时间" :value="userInfo.rechargeTime" />
        <van-cell title="充值卡号" :value="userInfo.rechargeCard" />
        <van-cell title="充值金额" :value="userInfo.rechargeMoney" />
        <van-cell title="赠送金额" :value="userInfo.giveMoney" />
        <van-cell title="卡内余额" :value="userInfo.cardMoney" />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      userInfo: {}, //充值详情
    };
  },
  created() {
    const _this = this;
    const { orderName, orderType } = this.$route.query;
    this.$http
      .post("api/order/queryOrderDetails", { orderName, orderType })
      .then((res) => {
        if (res.data.code === "0000") {
          const data = res.data.data.results.rechargeDetailsVo;
          data.rechargeTime = moment(data.rechargeTime).format('YYYY-MM-DD HH:mm:ss')
          _this.userInfo = Object.freeze(data)
        }
      });
  },
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/order/orderMoney.less");
</style>